<script setup lang="ts">
import type { Query } from '@directus/types'

definePageMeta({
  title: 'Literature',
  description: 'ICS product literature and other marketing materials.',
  order: 1,
})

const config = useRuntimeConfig()

const query: Query = {
  filter: {
    status: { _eq: 'published' },
    resource_type: { _eq: 'Literature' },
  },
}

const { data: literature } = await useFetch<DefaultResource[]>(
  '/api/items/resources',
  {
    key: 'page:literature:literature-resources',
    query,
    getCachedData: (key, nuxtApp) => nuxtApp.payload.data[key],
  },
)
</script>

<template>
  <BlockContent element="section">
    <h1 class="subpage-title mb-6">
      Literature Resources
    </h1>
    <p class="text-lg mb-12">
      Find our product literature and other marketing materials here.
    </p>
    <div class="flex flex-wrap gap-y-12 f-gap-x-48-64">
      <template
        v-for="document in literature"
        :key="document.id"
      >
        <div class="space-y-6 md:max-w-2/5">
          <h2 class="text-lg heading">
            {{ document.name }}
          </h2>
          <PdfThumb
            :pdf="document.pdf"
            :alt="`Preview of the document: ${document.name}`"
            class="elevation-3"
          />
          <AButton
            label="Download"
            color="blue"
            icon="i-carbon-download"
            :href="`${config.public.directusUrl}/assets/${document.pdf}?download`"
          />
          <div
            class="my-8 prose"
            v-html="document.description"
          />
        </div>
      </template>
    </div>
  </BlockContent>
</template>
